import { render } from "./form-type-dmarc.vue?vue&type=template&id=66073b30&ts=true"
import script from "./form-type-dmarc.vue?vue&type=script&lang=ts"
export * from "./form-type-dmarc.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__